import React from 'react';
import './SetViewToggle.css';

export type SetCardsView = 'table' | 'list';

interface SetViewToggleProps {
  view: SetCardsView;
  onChange: (view: SetCardsView) => void;
}

export const SetViewToggle: React.FC<SetViewToggleProps> = ({ view, onChange }) => (
  <div className="set-view-toggle" role="group" aria-label="Card display mode">
    <button
      type="button"
      className={`set-view-toggle-button ${view === 'table' ? 'set-view-toggle-button--active' : ''}`}
      aria-pressed={view === 'table'}
      onClick={() => onChange('table')}
    >
      Table
    </button>
    <button
      type="button"
      className={`set-view-toggle-button ${view === 'list' ? 'set-view-toggle-button--active' : ''}`}
      aria-pressed={view === 'list'}
      onClick={() => onChange('list')}
    >
      Card Details
    </button>
  </div>
);

export default SetViewToggle;
